import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { adminLogin as apiLogin, adminMe } from '../api';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('uae_admin_token') || '');
  const [username, setUsername] = useState('');
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    if (!token) {
      setReady(true);
      return;
    }
    adminMe(token)
      .then((d) => { if (active) setUsername(d.username); })
      .catch(() => {
        if (active) {
          setToken('');
          localStorage.removeItem('uae_admin_token');
        }
      })
      .finally(() => active && setReady(true));
    return () => { active = false; };
  }, [token]);

  const login = useCallback(async (u, p) => {
    const data = await apiLogin(u, p);
    localStorage.setItem('uae_admin_token', data.access_token);
    setToken(data.access_token);
    setUsername(data.username);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('uae_admin_token');
    setToken('');
    setUsername('');
  }, []);

  return (
    <AdminAuthContext.Provider value={{ token, username, isAuthed: !!token, ready, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used within AdminAuthProvider');
  return ctx;
}
